// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 查询权限点目录 查询权限点目录。系统管理员或运营管理员可调用（用于角色分配、权限回显等）。 GET /api/admin/rbac/permissions */
export async function listPermissionsApiAdminRbacPermissionsGet(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.listPermissionsApiAdminRbacPermissionsGetParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResponseListAdminPermissionResponse_>(
    "/api/admin/rbac/permissions",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 同步前端权限点清单 同步权限点目录（前端主导）。仅系统管理员可调用。

前端可在本地脚本或 CI 中调用该接口，提交菜单/页面/按钮权限清单，后端负责幂等入库。 POST /api/admin/rbac/permissions/sync */
export async function syncPermissionsApiApiAdminRbacPermissionsSyncPost(
  body: API.SyncPermissionsRequest,
  options?: { [key: string]: any }
) {
  return request<API.BaseResponseSyncPermissionsResponse_>(
    "/api/admin/rbac/permissions/sync",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 后台角色列表（分页） 查询后台角色列表。系统管理员或运营管理员可调用（用于角色分配等）。 GET /api/admin/rbac/roles */
export async function listAdminRolesApiAdminRbacRolesGet(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.listAdminRolesApiAdminRbacRolesGetParams,
  options?: { [key: string]: any }
) {
  return request<API.PaginatedResponseAdminRoleResponse_>(
    "/api/admin/rbac/roles",
    {
      method: "GET",
      params: {
        // current has a default value: 1
        current: "1",
        // pageSize has a default value: 10
        pageSize: "10",
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 创建后台角色 创建后台角色。系统管理员或运营管理员可调用。 POST /api/admin/rbac/roles */
export async function createAdminRoleApiApiAdminRbacRolesPost(
  body: API.CreateAdminRoleRequest,
  options?: { [key: string]: any }
) {
  return request<API.BaseResponseAdminRoleResponse_>("/api/admin/rbac/roles", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 更新后台角色 更新后台角色。系统管理员或运营管理员可调用。 PUT /api/admin/rbac/roles/${param0} */
export async function updateAdminRoleApiApiAdminRbacRolesRoleIdPut(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.updateAdminRoleApiApiAdminRbacRolesRoleIdPutParams,
  body: API.UpdateAdminRoleRequest,
  options?: { [key: string]: any }
) {
  const { role_id: param0, ...queryParams } = params;
  return request<API.BaseResponseAdminRoleResponse_>(
    `/api/admin/rbac/roles/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除后台角色 删除后台角色。系统管理员或运营管理员可调用。 DELETE /api/admin/rbac/roles/${param0} */
export async function deleteAdminRoleApiApiAdminRbacRolesRoleIdDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteAdminRoleApiApiAdminRbacRolesRoleIdDeleteParams,
  options?: { [key: string]: any }
) {
  const { role_id: param0, ...queryParams } = params;
  return request<API.BaseResponseDict_>(`/api/admin/rbac/roles/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 复制角色并继承权限 从已有角色复制新角色，并继承其权限点。系统管理员或运营管理员可调用。 POST /api/admin/rbac/roles/${param0}/clone */
export async function cloneRoleApiApiAdminRbacRolesRoleIdClonePost(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.cloneRoleApiApiAdminRbacRolesRoleIdClonePostParams,
  body: API.CloneAdminRoleRequest,
  options?: { [key: string]: any }
) {
  const { role_id: param0, ...queryParams } = params;
  return request<API.BaseResponseAdminRoleResponse_>(
    `/api/admin/rbac/roles/${param0}/clone`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取角色已分配权限 获取指定角色的权限快照（用于前端回显）。系统管理员或运营管理员可调用。 GET /api/admin/rbac/roles/${param0}/permissions */
export async function getRolePermissionsApiApiAdminRbacRolesRoleIdPermissionsGet(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getRolePermissionsApiApiAdminRbacRolesRoleIdPermissionsGetParams,
  options?: { [key: string]: any }
) {
  const { role_id: param0, ...queryParams } = params;
  return request<API.BaseResponseAdminRolePermissionsResponse_>(
    `/api/admin/rbac/roles/${param0}/permissions`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 设置角色权限点 覆盖设置角色权限点。系统管理员或运营管理员可调用；运营管理员禁止设置自己所属角色的权限。 PUT /api/admin/rbac/roles/${param0}/permissions */
export async function assignRolePermissionsApiApiAdminRbacRolesRoleIdPermissionsPut(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.assignRolePermissionsApiApiAdminRbacRolesRoleIdPermissionsPutParams,
  body: API.AssignRolePermissionsRequest,
  options?: { [key: string]: any }
) {
  const { role_id: param0, ...queryParams } = params;
  return request<API.BaseResponseAssignRolePermissionsResultResponse_>(
    `/api/admin/rbac/roles/${param0}/permissions`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}
